// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trigger-monitoring-container {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
    background-color: #f5f5f5;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

h2 {
    color: #305e7a;
    text-align: center;
}

.trigger-monitoring-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
}

.trigger-monitoring-table th,
.trigger-monitoring-table td {
    padding: 12px 15px;
    text-align: left;
}

.trigger-monitoring-table th {
    background-color: #305e7a;
    color: white;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 14px;
}

.trigger-monitoring-table td {
    background-color: white;
    color: #333;
    border-bottom: 1px solid #ddd;
    font-size: 14px;
}

.trigger-monitoring-table tr:last-child td {
    border-bottom: none;
}

.trigger-monitoring-table tr:hover td {
    background-color: #f1f1f1;
}
/* Add these styles */
/* Keep the fixed width styles */
.trigger-monitoring-table th:last-child,
.trigger-monitoring-table td:last-child {
  min-width: 150px;
  width: 150px;
}

/* Update the pending-timer class */
.pending-timer {
  display: inline-block;
  min-width: 100px;
  animation: flashing-turuncu 1.5s infinite ease-in-out;
  font-weight: bold;
}

/* Update the Ending Soon animation */
@keyframes flashing-turuncu {
    0% { color: #f9a825; }
    50% { color: #d97706; }
    100% { color: #f9a825; }
}

/* Remove the white-space property since it's not needed for the animation */
.trigger-monitoring-table td:last-child:not(.flashing-running):not(.flashing-pending) {
  white-space: nowrap;
}

/* Styling for main collapsible headers */
.collapsible-header {
    background-color: #e3f2fd; /* Light blue for Successful */
    cursor: pointer;
    font-weight: bold;
    padding: 10px;
  }
  
  /* Styling for Stopped section */
  .collapsible-header.stopped {
    background-color: #ffebee; /* Light red for Stopped */
  }
  
 /* Indentation for sub-collapsible date sections */
.sub-collapsible-header {
    background-color: #f0f0f0; /* Light gray background */
    cursor: pointer;
    font-weight: bold;
    padding-left: 25px; /* Indent sub-section */
    font-size: 8px; /* Smaller font size */
    font-weight: normal;
}

/* Optional: Adjust hover effect */
.sub-collapsible-header:hover {
    background-color: #e0e0e0;
}

  
  /* Indent job rows under date collapsible */
  .sub-collapsible-job {
    padding-left: 40px; /* Indent job rows */
  }
  
/* Make the status ball smaller */
.status-ball {
    font-size: 10px; /* Make the ball smaller */
    display: inline-block;
    width: 12px;
    height: 12px;
    line-height: 12px;
    text-align: center;
    margin-right: 5px; /* Add spacing */
}

.status-ball.blue {
    color: #265d94; /* Blue for Successful */
}

.status-ball.red {
    color: darkred; /* Red for Stopped */
}

/* Running (Green Flashing) */
@keyframes flashing-yesil {
    0% { color: #3bd267; } 
    50% { color: #0e5a20; } 
    100% { color: #3bd267; }
}
.trigger-monitoring-table td.flashing-running {
    font-weight: bold;
    animation: flashing-yesil 1.5s infinite ease-in-out;
}

/* Pending (Orange Flashing) */
@keyframes flashing-turuncu {
    0% { color: #f9a825; }
    50% { color: #d97706; }
    100% { color: #f9a825; }
}
.trigger-monitoring-table td.flashing-pending {
    font-weight: bold;
    animation: flashing-turuncu 1.5s infinite ease-in-out;
}

/* Stopped (Dark Red - No Flash) */
.trigger-monitoring-table td.stopped {
    font-weight: bold;
    color: darkred;
}

/* Successful (Blue - No Flash) */
.trigger-monitoring-table td.successful {
    font-weight: bold;
    color: #3272b3;
}
/* Disabled Automatically Text */
.disabled-automatically {
    font-weight: bold;
    color: darkred; /* Dark Red for visibility */
    font-size: 14px;
    font-family: "Courier New", monospace;
}

.disabled {
  color: #666;
  background-color: #f0f0f0;
}

.collapsible-header.disabled {
  background-color: #f0f0f0;
  cursor: pointer;
}

/* ==== INFO hücresi: kısalt + "View" linki ==== */
.info-cell {
  max-width: 420px;         /* tablo içinde genişliği kontrol et */
}

.info-cell .info-preview {
  display: inline-block;
  max-width: 380px;         /* butona yer kalsın diye biraz daha dar */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;  /* uzun metni ... ile kısalt */
  vertical-align: middle;
}

.link-button {
  margin-left: 8px;
  font-size: 12px;
  cursor: pointer;
  background: none;
  border: none;
  color: #1e6bb8;
  text-decoration: underline;
  padding: 0;
}
.link-button:hover { text-decoration: none; }

/* ==== Modal (tam metni gösterme) ==== */
.modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.45);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal {
  width: min(900px, 92vw);
  max-height: 80vh;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 20px 40px rgba(0,0,0,0.2);
  display: flex;
  flex-direction: column;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid #e5e7eb;
}

.modal-close {
  background: none;
  border: none;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  color: #334155;
}

.modal-body {
  padding: 12px 16px;
  overflow: auto;
}

.modal-pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
               "Liberation Mono", "Courier New", monospace;
  white-space: pre-wrap;    /* satır sonlarını koru, uzun satırları kır */
  word-break: break-word;
  line-height: 1.35;
  max-height: 55vh;
  overflow: auto;
  background: #0f172a;     /* koyu arka plan */
  color: #e2e8f0;          /* okunaklı açık renk yazı */
  border-radius: 6px;
  padding: 12px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding: 12px 16px;
  border-top: 1px solid #e5e7eb;
}

.modal-footer .primary {
  background: #305e7a;
  color: #fff;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
}

.modal-footer .secondary {
  background: #eef2f7;
  color: #1f2937;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/styles/TriggerMonitoring.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;AACA,qBAAqB;AACrB,gCAAgC;AAChC;;EAEE,gBAAgB;EAChB,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;EACrB,gBAAgB;EAChB,qDAAqD;EACrD,iBAAiB;AACnB;;AAEA,qCAAqC;AACrC;IACI,KAAK,cAAc,EAAE;IACrB,MAAM,cAAc,EAAE;IACtB,OAAO,cAAc,EAAE;AAC3B;;AAEA,4EAA4E;AAC5E;EACE,mBAAmB;AACrB;;AAEA,yCAAyC;AACzC;IACI,yBAAyB,EAAE,8BAA8B;IACzD,eAAe;IACf,iBAAiB;IACjB,aAAa;EACf;;EAEA,gCAAgC;EAChC;IACE,yBAAyB,EAAE,0BAA0B;EACvD;;CAED,kDAAkD;AACnD;IACI,yBAAyB,EAAE,0BAA0B;IACrD,eAAe;IACf,iBAAiB;IACjB,kBAAkB,EAAE,uBAAuB;IAC3C,cAAc,EAAE,sBAAsB;IACtC,mBAAmB;AACvB;;AAEA,kCAAkC;AAClC;IACI,yBAAyB;AAC7B;;;EAGE,2CAA2C;EAC3C;IACE,kBAAkB,EAAE,oBAAoB;EAC1C;;AAEF,iCAAiC;AACjC;IACI,eAAe,EAAE,0BAA0B;IAC3C,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB,EAAE,gBAAgB;AACvC;;AAEA;IACI,cAAc,EAAE,wBAAwB;AAC5C;;AAEA;IACI,cAAc,EAAE,oBAAoB;AACxC;;AAEA,6BAA6B;AAC7B;IACI,KAAK,cAAc,EAAE;IACrB,MAAM,cAAc,EAAE;IACtB,OAAO,cAAc,EAAE;AAC3B;AACA;IACI,iBAAiB;IACjB,mDAAmD;AACvD;;AAEA,8BAA8B;AAC9B;IACI,KAAK,cAAc,EAAE;IACrB,MAAM,cAAc,EAAE;IACtB,OAAO,cAAc,EAAE;AAC3B;AACA;IACI,iBAAiB;IACjB,qDAAqD;AACzD;;AAEA,kCAAkC;AAClC;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,iCAAiC;AACjC;IACI,iBAAiB;IACjB,cAAc;AAClB;AACA,gCAAgC;AAChC;IACI,iBAAiB;IACjB,cAAc,EAAE,4BAA4B;IAC5C,eAAe;IACf,qCAAqC;AACzC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,gBAAgB,UAAU,sCAAsC;AAClE;;AAEA;EACE,qBAAqB;EACrB,gBAAgB,UAAU,0CAA0C;EACpE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB,GAAG,8BAA8B;EACxD,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,0BAA0B;EAC1B,UAAU;AACZ;AACA,qBAAqB,qBAAqB,EAAE;;AAE5C,yCAAyC;AACzC;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE;0DACwD;EACxD,qBAAqB,KAAK,6CAA6C;EACvE,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB,MAAM,mBAAmB;EAC5C,cAAc,WAAW,4BAA4B;EACrD,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB","sourcesContent":[".trigger-monitoring-container {\n    padding: 20px;\n    max-width: 1200px;\n    margin: 0 auto;\n    background-color: #f5f5f5;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\nh2 {\n    color: #305e7a;\n    text-align: center;\n}\n\n.trigger-monitoring-table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 20px;\n}\n\n.trigger-monitoring-table th,\n.trigger-monitoring-table td {\n    padding: 12px 15px;\n    text-align: left;\n}\n\n.trigger-monitoring-table th {\n    background-color: #305e7a;\n    color: white;\n    font-weight: bold;\n    text-transform: uppercase;\n    font-size: 14px;\n}\n\n.trigger-monitoring-table td {\n    background-color: white;\n    color: #333;\n    border-bottom: 1px solid #ddd;\n    font-size: 14px;\n}\n\n.trigger-monitoring-table tr:last-child td {\n    border-bottom: none;\n}\n\n.trigger-monitoring-table tr:hover td {\n    background-color: #f1f1f1;\n}\n/* Add these styles */\n/* Keep the fixed width styles */\n.trigger-monitoring-table th:last-child,\n.trigger-monitoring-table td:last-child {\n  min-width: 150px;\n  width: 150px;\n}\n\n/* Update the pending-timer class */\n.pending-timer {\n  display: inline-block;\n  min-width: 100px;\n  animation: flashing-turuncu 1.5s infinite ease-in-out;\n  font-weight: bold;\n}\n\n/* Update the Ending Soon animation */\n@keyframes flashing-turuncu {\n    0% { color: #f9a825; }\n    50% { color: #d97706; }\n    100% { color: #f9a825; }\n}\n\n/* Remove the white-space property since it's not needed for the animation */\n.trigger-monitoring-table td:last-child:not(.flashing-running):not(.flashing-pending) {\n  white-space: nowrap;\n}\n\n/* Styling for main collapsible headers */\n.collapsible-header {\n    background-color: #e3f2fd; /* Light blue for Successful */\n    cursor: pointer;\n    font-weight: bold;\n    padding: 10px;\n  }\n  \n  /* Styling for Stopped section */\n  .collapsible-header.stopped {\n    background-color: #ffebee; /* Light red for Stopped */\n  }\n  \n /* Indentation for sub-collapsible date sections */\n.sub-collapsible-header {\n    background-color: #f0f0f0; /* Light gray background */\n    cursor: pointer;\n    font-weight: bold;\n    padding-left: 25px; /* Indent sub-section */\n    font-size: 8px; /* Smaller font size */\n    font-weight: normal;\n}\n\n/* Optional: Adjust hover effect */\n.sub-collapsible-header:hover {\n    background-color: #e0e0e0;\n}\n\n  \n  /* Indent job rows under date collapsible */\n  .sub-collapsible-job {\n    padding-left: 40px; /* Indent job rows */\n  }\n  \n/* Make the status ball smaller */\n.status-ball {\n    font-size: 10px; /* Make the ball smaller */\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    line-height: 12px;\n    text-align: center;\n    margin-right: 5px; /* Add spacing */\n}\n\n.status-ball.blue {\n    color: #265d94; /* Blue for Successful */\n}\n\n.status-ball.red {\n    color: darkred; /* Red for Stopped */\n}\n\n/* Running (Green Flashing) */\n@keyframes flashing-yesil {\n    0% { color: #3bd267; } \n    50% { color: #0e5a20; } \n    100% { color: #3bd267; }\n}\n.trigger-monitoring-table td.flashing-running {\n    font-weight: bold;\n    animation: flashing-yesil 1.5s infinite ease-in-out;\n}\n\n/* Pending (Orange Flashing) */\n@keyframes flashing-turuncu {\n    0% { color: #f9a825; }\n    50% { color: #d97706; }\n    100% { color: #f9a825; }\n}\n.trigger-monitoring-table td.flashing-pending {\n    font-weight: bold;\n    animation: flashing-turuncu 1.5s infinite ease-in-out;\n}\n\n/* Stopped (Dark Red - No Flash) */\n.trigger-monitoring-table td.stopped {\n    font-weight: bold;\n    color: darkred;\n}\n\n/* Successful (Blue - No Flash) */\n.trigger-monitoring-table td.successful {\n    font-weight: bold;\n    color: #3272b3;\n}\n/* Disabled Automatically Text */\n.disabled-automatically {\n    font-weight: bold;\n    color: darkred; /* Dark Red for visibility */\n    font-size: 14px;\n    font-family: \"Courier New\", monospace;\n}\n\n.disabled {\n  color: #666;\n  background-color: #f0f0f0;\n}\n\n.collapsible-header.disabled {\n  background-color: #f0f0f0;\n  cursor: pointer;\n}\n\n/* ==== INFO hücresi: kısalt + \"View\" linki ==== */\n.info-cell {\n  max-width: 420px;         /* tablo içinde genişliği kontrol et */\n}\n\n.info-cell .info-preview {\n  display: inline-block;\n  max-width: 380px;         /* butona yer kalsın diye biraz daha dar */\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;  /* uzun metni ... ile kısalt */\n  vertical-align: middle;\n}\n\n.link-button {\n  margin-left: 8px;\n  font-size: 12px;\n  cursor: pointer;\n  background: none;\n  border: none;\n  color: #1e6bb8;\n  text-decoration: underline;\n  padding: 0;\n}\n.link-button:hover { text-decoration: none; }\n\n/* ==== Modal (tam metni gösterme) ==== */\n.modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.45);\n  z-index: 999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.modal {\n  width: min(900px, 92vw);\n  max-height: 80vh;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 20px 40px rgba(0,0,0,0.2);\n  display: flex;\n  flex-direction: column;\n}\n\n.modal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.modal-close {\n  background: none;\n  border: none;\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n  color: #334155;\n}\n\n.modal-body {\n  padding: 12px 16px;\n  overflow: auto;\n}\n\n.modal-pre {\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,\n               \"Liberation Mono\", \"Courier New\", monospace;\n  white-space: pre-wrap;    /* satır sonlarını koru, uzun satırları kır */\n  word-break: break-word;\n  line-height: 1.35;\n  max-height: 55vh;\n  overflow: auto;\n  background: #0f172a;     /* koyu arka plan */\n  color: #e2e8f0;          /* okunaklı açık renk yazı */\n  border-radius: 6px;\n  padding: 12px;\n}\n\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 12px 16px;\n  border-top: 1px solid #e5e7eb;\n}\n\n.modal-footer .primary {\n  background: #305e7a;\n  color: #fff;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.modal-footer .secondary {\n  background: #eef2f7;\n  color: #1f2937;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
